export default "__VITE_ASSET__Bxd0IR4e__"